export class NotificationTemplateModel {
    id = 0;
    name = "";
    subject = "";
    body = "";
    sourceTypes = [] as number[]
    cultureCode = "";
    recipients = [] as number[];
    attachments = [] as number[];
    translations = [] as NotificationTemplateTranslationModel[];

    notificationScheduleId = null as number | null;
}

export type NotificationTemplateViewModel = {
    id: number;
    name: string;
    subject: string;
    sourceTypeIds: number[];
    isDefault: boolean;
}

export class NotificationTemplateTranslationModel {
    id = 0;
    subject = "";
    body = "";
    cultureCode = "";
}

export type TemplateVariable = {
    name: string;
    htmlPreview: string;
    htmlPreviewSimple: string;
}